import { ActivityEventDictionary, ActivityEventGroups } from './types';

// Presentation only. Names and membership come from /activity/dictionary/events.
const CATEGORY_COLORS: Record<string, { color: string; background: string }> = {
  'Orders & disputes': { color: '#6A1BF5', background: '#F0E9FF' },
  'Fraud & risk': { color: '#B4231A', background: '#FEECEB' },
  Collections: { color: '#8A4B00', background: '#FFF3DD' },
  Cognito: { color: '#0F6E56', background: '#E6F4EE' },
  'Selling channels': { color: '#3F4B5B', background: '#EEF1F5' },
  Billing: { color: '#8A4B00', background: '#FFF3DD' },
  Shipping: { color: '#007B83', background: '#E6F6F6' },
  Rewards: { color: '#8B4290', background: '#F7ECF8' },
  Account: { color: '#1D4ED8', background: '#EBF1FF' },
};

export const categoryStyle = (name: string) =>
  CATEGORY_COLORS[name] || { color: '#5C5C70', background: '#F4F4F8' };

export const indexEvents = (groups: ActivityEventGroups): ActivityEventDictionary =>
  Object.keys(groups).reduce((dictionary, group) => {
    groups[group].forEach((event) => {
      dictionary[event.value] = { ...event, group };
    });
    return dictionary;
  }, {} as ActivityEventDictionary);

export const isEventGroups = (data: any): data is ActivityEventGroups =>
  data !== null &&
  typeof data === 'object' &&
  !Array.isArray(data) &&
  Object.keys(data).every(
    (group) =>
      Array.isArray(data[group]) &&
      data[group].every(
        (event) => event && typeof event.name === 'string' && typeof event.value === 'string'
      )
  );

export const eventLabel = (event: string | null, dictionary: ActivityEventDictionary) =>
  event ? dictionary[event]?.name || event : 'Other activity';

export const eventCategory = (event: string | null, dictionary: ActivityEventDictionary) => {
  const name = (event && dictionary[event]?.group) || 'Other';
  return { name, ...categoryStyle(name) };
};
